import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api } from './api';

export interface Me {
  user: { id: string; email: string; name: string; role: string; mustChangePassword?: boolean };
  publishMode?: 'simulated' | 'assisted' | 'auto';
  permissions: string[];
  env: string;
  llm: string;
}

interface AuthCtx {
  me: Me | null;
  loading: boolean;
  refresh(): Promise<void>;
  can(p: string): boolean;
  logout(): Promise<void>;
}

const Ctx = createContext<AuthCtx>(null as never);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  const refresh = async () => {
    try {
      setMe(await api<Me>('/api/me'));
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    void refresh();
  }, []);
  return (
    <Ctx.Provider
      value={{
        me,
        loading,
        refresh,
        can: (p) => !!me?.permissions.includes(p),
        logout: async () => {
          await api('/api/auth/logout', { method: 'POST' });
          setMe(null);
        },
      }}
    >
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);

export const ROLE_LABEL: Record<string, string> = {
  ALL: 'Todas as exigências pendentes (CEO)',
  CEO: 'CEO',
  MARKETING_SPONSOR: 'Sponsor de Marketing',
  TECH_REVIEWER: 'Revisor Técnico',
  SALES_MANAGER: 'Gerente Comercial',
  FINANCE_LEGAL: 'Financeiro/Jurídico',
  REQUESTER: 'Solicitante',
  AUDITOR: 'Auditor',
  SYSTEM_ADMIN: 'Admin de Sistema',
};
